module.exports = __webpack_public_path__ + "img/guyue-logo.2c750586.png";